// custom hook to autofocus field when component is not on top level
import { useEffect, useRef } from "react";

export function useFocusableInput ( shouldFocus, waitTime = 0 ) {
	const inputRef    = useRef ( null );
	const setInputRef = instance => {
		inputRef.current = instance;
	};

	useEffect ( () => {
		let timeout;

		if ( shouldFocus ) {
			timeout = setTimeout ( () => {
				inputRef.current?.focus ();
			}, waitTime );
		}

		return () => {
			if ( timeout ) {
				clearTimeout ( timeout );
			}
		};
	}, [ shouldFocus ] );

	return {
		setInputRef
	};
}
